/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitCardCustomizationForReview} from '../api'

export const useMutationSubmitCardCustomizationForReview = createReactQueryMutationHook('submitCardCustomizationForReview', submitCardCustomizationForReview)
